import React from "react";
import { Box, Button, Container, Link, Typography } from "@mui/material";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

const AccountDeletionRequested: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation() as { state?: { email?: string } };
  const email = location.state?.email;

  return (
    <Container maxWidth="sm" sx={{ py: 6, textAlign: "center" }}>
      <Typography variant="h4" gutterBottom>
        Solicitação enviada
      </Typography>
      <Typography variant="body1" gutterBottom>
        Enviamos um e-mail para{" "}
        {email ? <strong>{email}</strong> : "seu endereço"} com o link de
        confirmação. Assim que você confirmar, a exclusão acontecerá
        imediatamente e não poderá ser desfeita.
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Não recebeu? Verifique a caixa de spam ou tente novamente mais tarde.
      </Typography>

      <Box sx={{ mt: 3, display: "flex", gap: 1, justifyContent: "center" }}>
        <Button variant="contained" onClick={() => navigate("/")}>
          Voltar ao início
        </Button>
        <Button variant="outlined" component={RouterLink} to="/deletar-conta">
          Fazer nova solicitação
        </Button>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
        Precisa de ajuda? Escreva para{" "}
        <Link href="mailto:contato@mercado-agil.com">
          contato@mercado-agil.com
        </Link>
        .
      </Typography>
    </Container>
  );
};

export default AccountDeletionRequested;
